import 'reflect-metadata';
import { Container } from 'inversify';
import { PopupHttpGateway } from './popup.http.gateway';
import { GetPopupUseCase } from '../application/get-popup.use-case';
import { httpApi } from '../../common/infra/http';

export const Registry = {
    AxiosAdapter: Symbol.for('AxiosAdapter'),
    PopupGateway: Symbol.for('PopupGateway'),
    PopupUseCase: Symbol.for('PopupUseCase'),
};

export const container = new Container();

container.bind(Registry.AxiosAdapter).toConstantValue(httpApi);

container.bind(Registry.PopupGateway).toDynamicValue((context) => {
    return new PopupHttpGateway(context.container.get(Registry.AxiosAdapter));
});

container.bind(Registry.PopupUseCase).toDynamicValue((context) => {
    return new GetPopupUseCase(context.container.get(Registry.PopupGateway));
});

const popup = {
    get: container.get<GetPopupUseCase>(Registry.PopupUseCase),
};
export default popup;
